export default __webpack_public_path__ + "static/Lato-Normal-d3d3bef854df0b84175b1e0e3b768f2a.woff";